import React, { useState } from 'react';
import { Modal, Form, Input, Select, Space } from 'antd';
import { ApproveAction } from '../../../services/p9513Api';

interface Props {
  open: boolean;
  type: 'leave' | 'trip';
  count: number;
  onConfirm: (action: ApproveAction, remarks: string) => void;
  onCancel: () => void;
  loading?: boolean;
}

const actionOptions = [
  { label: '核准 (Y)', value: 'Y' },
  { label: '拒絕 (N)', value: 'N' },
  { label: '代理核准 (P)', value: 'P' },
];

const ApproveModal: React.FC<Props> = ({ open, type, count, onConfirm, onCancel, loading }) => {
  const [action, setAction] = useState<ApproveAction>('Y');
  const [remarks, setRemarks] = useState('');

  const typeName = type === 'leave' ? '請假單' : '出差單';

  const handleOk = () => {
    if (action === 'N' && !remarks.trim()) {
      // Handled by server-side validation, but show UX hint here too
      return;
    }
    onConfirm(action, remarks);
  };

  const handleCancel = () => {
    setAction('Y');
    setRemarks('');
    onCancel();
  };

  return (
    <Modal
      title={`處理 ${typeName}（共 ${count} 筆）`}
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="確認執行"
      cancelText="取消"
      confirmLoading={loading}
      okButtonProps={{ danger: action === 'N' }}
    >
      <Form layout="vertical" size="small">
        <Form.Item label="動作" required>
          <Select
            value={action}
            onChange={(v) => setAction(v as ApproveAction)}
            options={actionOptions}
            style={{ width: '100%' }}
          />
        </Form.Item>
        <Form.Item
          label="備註 / 拒絕原因"
          required={action === 'N'}
          validateStatus={action === 'N' && !remarks.trim() ? 'error' : ''}
          help={action === 'N' && !remarks.trim() ? '拒絕時必須填寫拒絕原因' : ''}
        >
          <Input.TextArea
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            rows={3}
            placeholder={action === 'N' ? '請填寫拒絕原因（必填）' : '備註（選填）'}
          />
        </Form.Item>
      </Form>
      {action !== 'Y' && (
        <Space style={{ color: action === 'N' ? '#cf1322' : '#fa8c16' }}>
          {action === 'N' ? '⚠️ 拒絕後將通知員工及部門主管' : '代理核准將以您的帳號記錄'}
        </Space>
      )}
    </Modal>
  );
};

export default ApproveModal;
